<template>
    <div class="fiscan-paper" id="fiscan-paper" v-if="value" ref="fiscanPaper">
        <header class="paper-header">
            <div class="paper-title">
                <img src="../../assets/images/common/nav_logo.png" alt="">
                <h1 v-if="paperInfo.title">{{ paperInfo.title }}</h1>
                <h1 v-else-if="type==='practice'">职鉴练习</h1>
                <el-button @click="closeFn" type="danger" size="small" round><i class="nucfont inuc-close"></i>
                </el-button>
            </div>
            <div class="paper-info">
                <ul>
                    <li>
                        <h5>{{ $t('exam.totalCount') }}</h5>
                        <p><b>{{ topics.length }}</b> {{ $t('exam.question') }}</p>
                    </li>
                    <li v-if="paperInfo.totalScore">
                        <h5>{{ $t('paper.totalScore') }}</h5>
                        <p><b>{{ paperInfo.totalScore }}</b> {{ $t('paper.points') }}</p>
                    </li>
                    <li v-if="paperInfo.totalSeconds">
                        <h5>{{ $t('exam.period') }}</h5>
                        <p><b>{{ Math.floor(paperInfo.totalSeconds / 60) }}</b> {{ $t('exam.min') }}</p>
                    </li>
                    <li v-if="paperInfo.score">
                        <h5>{{ $t('exam.score') }}</h5>
                        <p><b>{{ paperInfo.score }}</b> {{ $t('paper.points') }}</p>
                    </li>
                    <li v-if="paperInfo.passScore">
                        <h5>{{ $t('count.passScore') }}</h5>
                        <p><b>{{ paperInfo.passScore }}</b> {{ $t('paper.points') }}</p>
                    </li>
                    <li v-if="paperInfo.form">
                        <h5>考试模式</h5>
                        <p>
                            <b>{{ paperFormName }}</b>
                        </p>
                    </li>
                </ul>
                <div class="clock" v-if="isExam && !loading">
                    <i class="nucfont inuc-clock"></i>
                    <span class="left-time">{{$t('exam.loading')}}</span>
                </div>
            </div>
        </header>

        <div class="paper-container">
            <div class="paper-main" v-if="currentTopic">

                <section class="paper-left">
                    <section class="paper-list">
                        <!-- 图片描述 -->
                        <div class="image-info-wrap" v-if="this.isView">
                            <div class="image-info">
                                <h3 class="title">{{number}}、{{ currentImage.name }}</h3>
                                <div class="item">
                                    <h5>标准答案：</h5>
                                    <span>{{ currentImage.isSafe ? '安全' : '危险' }}</span>
                                </div>
                                <div class="item" v-if="currentImage.isSafe">
                                    <h5>包裹类型：</h5>
                                    <span>空包</span>
                                </div>
                                <div class="item" v-else>
                                    <h5>违禁品类型：</h5>
                                    <div class="knowledges">
                                        <el-tag class="knowledge" v-for="(name, i) in currentImage.knowledges" :key="i" type="danger" size="mini">{{name}}</el-tag>
                                    </div>
                                </div>
                                <div class="item">
                                    <h5>图像描述：</h5>
                                    <span>{{ currentImage.description }}</span>
                                </div>
                            </div>

                            <el-divider class="info-divider"></el-divider>

                            <div class="image-info" v-if="currentAnswer">
                                <div class="item">
                                    <h5>学员答案：</h5>
                                    <span v-if="currentAnswer.isPass === null" class="result-text empty">未作答</span>
                                    <span v-else class="result-text" :class="{'right':currentAnswer.result==1}">{{ currentAnswer.isPass ? '安全' : '危险' }}</span>
                                </div>
                                <div class="item" v-if="!currentAnswer.result">
                                    <h5>错误原因：</h5>
                                    <span v-if="currentAnswer.isPass === null" class="result-text empty">未作答</span>
                                    <span v-else-if="(currentImage.isSafe && !currentAnswer.isPass) || (!currentImage.isSafe && currentAnswer.isPass)"
                                          class="result-text">判断错误</span>
                                    <span v-else-if="paperInfo.form>1" class="result-text">位置标记错误</span>
                                </div>
                                <div class="item result">
                                    <h5>最终结果：</h5>
                                    <el-tag v-if="currentAnswer.result===1" size="mini" type="success" effect="dark"><i class="nucfont inuc-check-line"></i> {{ currentAnswer.resultName }}</el-tag>
                                    <el-tag v-else size="mini" type="danger" effect="dark"><i class="nucfont inuc-close-line"></i> {{ currentAnswer.resultName }}</el-tag>
                                </div>
                            </div>
                        </div>

                        <div class="image-info-wrap" v-else>
                            <div class="image-info">
                                <h3 class="title title-exam">{{number}}、{{paperFormName}}
                                    <i style="vertical-align: 2px">|</i> {{currentImage.productName}}</h3>
                            </div>
                        </div>

                        <!-- 图片区域 -->
                        <div class="image-move-area">
                            <div class="image-show-wrap">
                                <div class="zoom-container" ref="bigImage">
                                    <img
                                        :src="currentImageUrl"
                                        ref="xrayImage"
                                        class="xray-image"
                                        :key="number+'image'"
                                        @click="addMark"
                                        alt="" />
                                    <ul class="sign-area-list">
                                        <li class="sign-area"
                                            v-for="item in currentImage.marks"
                                            :style="{position: absolute,display: block,height:item.height*100+'%', width:item.width*100+'%', top:item.top*100+'%', left:item.left*100+'%'}"
                                            :key="item.tipId"
                                            @click="viewTipDetail(item.tipId)"
                                            :class="{'disabled': !item.tipId}"
                                        >
                                            <div class="tooltip sign-tip" :class="[item.left>0.65?'left':'right']">
                                                <div class="tooltip-arrow"></div>
                                                <div class="tooltip-inner">
                                                    {{ item.knowledgeName }}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                    <ul class="mark-record-list" v-if="currentAnswer&&currentAnswer.tags">
                                        <li class="mark-record"
                                            v-for="(item, index) in currentAnswer.tags"
                                            @click="delMark(index)"
                                            :key="item"
                                            :style="{
                                                top: item.y*100+'%',
                                                left: item.x*100+'%',
                                                transform: 'translate(-14px, -14px)',
                                            }">

                                            <div class="tooltip sign-tip right">
                                                <div class="tooltip-arrow"></div>
                                                <div class="tooltip-inner" v-if="item.tagName">
                                                    {{ item.tagName }}
                                                </div>
                                                <div class="tooltip-inner tooltip-inner-mark" v-else>
                                                    <i class="nucfont inuc-close-line"></i>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <ul class="image-operate">
                            <li class="operate-item"
                                v-for="(item, index) in imageOperate"
                                :class="[item.className,{'active': item.type === currentType}]"
                                @click="operateClick(item.type)"
                                :key="'opr'+index"
                                :title="item.name">
                            </li>
                            <li class="operate-reset" title="重置图像" @click="resetZoom(true)"><i class="nucfont inuc-reset"></i></li>
                        </ul>

                        <div class="judge-btn-group" v-if="isFill">
                            <el-button @click="onChoose(true)" class="btn-safe" type="success"
                                       :key="number+'safe'"
                                       :plain="currentAnswer.isPass!==true">
                                <i v-if="currentAnswer.isPass===true" class="nucfont inuc-radio-active"></i>安全
                            </el-button>
                            <el-button @click="onChoose(false)" class="btn-danger" type="danger"
                                       :key="number+'danger'"
                                       :plain="currentAnswer.isPass!==false">
                                <i v-if="currentAnswer.isPass===false" class="nucfont inuc-radio-active"></i>嫌疑
                            </el-button>
                        </div>

                    </section>
                    <!-- 题目结束 -->
                </section>

                <!-- 侧边栏 -->
                <aside class="fiscan-paper-aside animated"
                       :class="{'fiscan-paper-aside-plain': isFill,
                           'hide': collapse,
                           'show': !collapse
                       }"
                       :key="paperInfo.guid"
                       :title="collapse ? '展开': '折叠'"
                >
                    <div class="aside-header" @click="collapse = !collapse">
                        <i class="nucfont" :class="collapse ? 'inuc-menu-fold': 'inuc-menu-unfold'"></i>
                        <span class="aside-header-title">题目列表</span>
                    </div>
                    <div class="img-list" style="bottom: 121px;">
                        <div class="info" v-for="(item,index) in topics" :key="item.topicID"
                             @click="clickTopicList(item.topicID)"
                             :class="{'active': item.topicID == currentTopic.topicID}"
                             :title="(item.topic && isFill) ? item.topic.image.productName: item.topic.image.name"
                        >
                            <span class="index">{{ index + 1 }}</span>
                            <div class="avatar">
                                <img alt="" :src="item.topic.url">
                            </div>
                            <div class="meta" v-if="item.topic">{{ isFill ? item.topic.image.productName: item.topic.image.name }}</div>
                            <div class="result" v-if="isView && !isPreview && item.answer">
                                <span class="status empty" v-if="item.answer.isPass===null"><i class="nucfont inuc-question"></i></span>
                                <span class="status right" v-else-if="item.answer.result === 1"><i class="nucfont inuc-check-line"></i></span>
                                <span class="status wrong" v-else><i class="nucfont inuc-close-line"></i></span>
                            </div>
                            <span class="answered" v-if="isFill && item.answered"><i class="nucfont inuc-correct"></i></span>
                            <!-- 折叠情况下 -->
                            <span class="un-answer" v-if="collapse && isFill && !item.answered"><i class="nucfont inuc-question"></i></span>
                        </div>
                    </div>
                </aside>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="btn-group-affix">
            <div class="btn-group-affix-inner">
                <el-button-group class="btn-switch-wrap" v-if="this.topics.length>0">
                    <el-button @click="lastOne" size="medium" :disabled="number===1" icon="el-icon-arrow-left"
                               :type="isFill && this.paperInfo.form === 1 ? '':'primary'">上一题</el-button>
                    <el-button @click="nextOne" size="medium" :disabled="number===topics.length"
                               :type="isFill && this.paperInfo.form === 1 ? '':'primary'">下一题<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-button-group>
                <el-button class="btn-submit" v-if="isFill"
                           @click="toSubmit" type="primary" size="medium">{{$t('exam.submit')}}</el-button>
            </div>
        </div>

        <div class="fullscreen-wrapper" v-if="loading">
            <div class="sk-grid">
                <div class="sk-grid-cube" v-for="n in 9"></div>
            </div>
            <p>{{ $t('stu.loadingExamTip') }}</p>
        </div>

        <fiscan-paper-result
            v-model="showResult"
            :id="resultID"
            :type="type"
            @close-result="onResultClose"
        />

        <!-- 类型选择弹框 -->
        <fiscan-kp-selector
            v-model="kpSelector"
            @submit="submitTagKp"
        />

        <!-- 包内物品详情 -->
        <fiscan-kp-detail
            v-model="kpDetailShow"
            :id="kpDetailId"
        />

        <!-- 消息弹框 -->
        <!-- 因为对页面进行了全屏，所以不能直接用加在body上的confirm组件 -->
        <el-dialog
            custom-class="modal-message"
            :visible.sync="showModal"
            top="30vh"
            width="450px"
            :title="$t('m.tip')"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
        >
            <span><i class="icon-warn el-icon-warning"></i>{{modalMessage}}</span>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="showModal = false" size="small">取消</el-button>
                <el-button type="primary" @click="submitPaper" size="small">确定</el-button>
              </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
/**
 * todo:
 * 、右侧栏滚动条随着焦点走
 * 、优化职鉴考卷样式
 */
import {screenfull, isEmpty, CountDown, Storage} from '@/utils';
import {FISCAN_OPERATE} from '@/config/constant'
import panzoom from 'panzoom'
import FiscanPaperResult from "./FiscanPaperResult";
import FiscanKpSelector from "./FiscanKpSelector";
import FiscanKpDetail from "./FiscanKpDetail";

export default {
    components: {
        FiscanPaperResult,
        FiscanKpSelector,
        FiscanKpDetail
    },

    props: {
        // v-model
        value: {
            type: Boolean,
            default: false
        },
        // 接口返回的试卷数据
        data: {
            type: Object,
            required: true
        },
        /**
         *  用途 {Number}
         *  考卷作答：1
         *  考卷查看：2
         */
        usage: {
            type: Number,
            required: true
        },
        /**
         * 试卷类型 {String}
         * 考试：exam
         * 模拟考试：mockExam
         * 练习：practice
         * 预览：preview
         **/
        type: {
            type: String,
            required: true
        },
        // 是否是一个新的补考试卷，是的话不取本地缓存数据
        isResitPaperClean: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            number: 1,
            topics: [],
            response: [],          // 作答数据
            currentTopic: {},
            currentImage: {
                name: '',
                isSafe: false,
                description: '',
                marks: [],
                knowledges: [],
            },
            currentImageUrl: '',
            currentAnswer: {},
            currentType: 0,
            imageOperate: FISCAN_OPERATE,
            kpDetailShow: false,
            kpDetailId: '',
            kpSelector: false,
            showResult: false,
            resultID: '',
            showModal: false,
            modalMessage: '',
            loading: true,
            panning: false,
            config: {
                maxWaitTime: 3000,
                savedTime: 30,
            },
            collapse: false
        }
    },

    computed: {
        paperInfo() {
            if (this.data?.paper) {
                const paperInfo = {}
                Object.assign(paperInfo, this.data, this.data.paper)
                delete paperInfo.paper
                return paperInfo
            }

            return this.data || {}
        },
        // 用于保存答案的 localStorage key
        localKey() {
            if (this.type === 'exam') {
                return `fiscan_exam_${this.paperInfo.testID}`
            } else if (this.type === 'mockExam') {
                return `fiscan_mock_${this.paperInfo.guid}`
            }
        },
        paperFormName() {
            const formMap = {
                1: this.$t('stu.quickJudge'),
                2: this.$t('stu.markLocation'),
                3: this.$t('stu.markLocationAndJudge')
            }

            if (this.paperInfo.form) {
                return formMap[this.paperInfo.form]
            }

            return ''
        },
        // 考卷作答 = 练习 || 考试 || 模拟考试
        isFill() {
            return this.usage === 1
        },
        // 考卷查看 = 考卷回查 || 组卷预览
        isView() {
            return this.usage === 2
        },
        // 考试 = 考试 || 模拟考试
        isExam() {
            return this.isFill && (this.type === 'exam' || this.type === 'mockExam')
        },
        // 组卷预览
        isPreview() {
            return this.usage === 2 && this.type === 'preview'
        },
        // 可否进行标记。作答模式下，并且模式不为快速判断，并且没在图片操作的过程中，可以标记
        canMark() {
            return this.isFill && this.paperInfo.form !== 1 && !this.panning
        }
    },

    watch: {
        value: {
            handler(v) {
                if (v) {
                    this.onShow()
                }
            },
            immediate: true
        },
        data(value) {
            if (!isEmpty(value)) {
                this.onPaperData(value)
            }
        },
        number() {
            this.resetZoom()
            this.loadCurrent()

            if (this.isExam) {
                this.savePaperOnLocal()
            }
        },
    },

    methods: {
        onShow() {
            //this.fullScreen()

            // 初始化
            this.loading = true
            this.reset()
            this.initEvents()
        },

        onPaperData(data) {
            // 填充作答数据
            this.fillResponse(data)

            // 加载考题数据
            this.fillTopics(data)

            // 更新当前相关数据
            this.loadCurrent()

            // 判断第一张图片是否加载完毕
            // 加载完毕后，开始主流程（取消loading，进行倒计时）
            this.loadFirstImage()

            // 已废弃 --- 因为侧边栏有所有的图片，会直接加载所有的图片，所以预加载是多余的
            // 预加载接下来的图片
            // this.preloadImages()
        },

        // 提前加载第一张图片，加载完毕后再开始主流程，目的是保证第一张图不闪
        loadFirstImage() {
            const img = new Image()
            img.src = this.topics[0].topic?.url
            img.onload = () => {
                this.loading = false
                if (this.isExam) {
                    !this.cd && this.initCountDown()
                }
            }

            // 已废弃 --- 低效且不稳定的实现方式
            /*
            const img = this.$refs.xrayImage

            // 保证第一张图片不被缓存，从而顺利进入onload事件
            if (this.number === 1 && this.loading) {
                this.currentImageUrl += '?'+new Date().valueOf()
            }

            // 监听第一张图片的加载完成事件
            $(img).on('load.img', async () => {
                $(this.$refs.xrayImage).off('load.img')
                await new Promise(resolve => setTimeout(resolve, 300))
                this.loading = false

                if (this.isExam) {
                    !this.cd && this.initCountDown()
                }
                console.log('on loaded')
            })

            // 图片已加载或图片加载失败的后备处理
            // 目的是为了让loading不能一直为ture
            setTimeout(() => {
                if (this.loading) {
                    this.loading = false
                    if (this.isExam) {
                        !this.cd && this.initCountDown()
                    }
                    console.log('on back up loaded')
                }
            }, this.config.maxWaitTime)
            */
        },

        preloadImages() {
            let imgList = []
            this.topics.forEach((item, index) => {
                imgList[index] = new Image()
                imgList[index].src = item.topic?.url
            })
        },

        fillResponse(data) {
            if (this.type === 'exam' || this.type === 'mockExam') {
                this.response = data.records
            }

            if (this.type === 'practice') {
                this.response = data.response
            }

            // 加载本地数据
            const localResponse = Storage.get(this.localKey)
            if (this.isExam && localResponse) {
                if (!this.isResitPaperClean) {
                    this.response = localResponse;
                } else {
                    // 每次点击补考按钮，都是一个新的考卷
                    Storage.remove(this.localKey);
                }
            }
        },

        fillTopics(data) {
            if (this.type === 'exam' || this.type === 'mockExam') {
                this.topics = data.paper?.relationship || []

                this.topics.forEach(item => {
                    const im = this.response.find(v => v.topicID === item.topicID)
                    if (im && im.isPass!==null) {
                        item.answered = true
                    }
                })
            }

            if (this.type === 'practice') {
                this.topics = data.fiscan.map(item => {
                    return {
                        topic: item,
                        topicID: item.id,
                        key: false,
                        score: 0
                    }
                })
            }

            if (this.type === 'preview') {
                this.topics = data.relationship
            }

            if (this.isView && this.topics) {
                this.topics.forEach(item => {
                    item.answer = this.response.find(res => res.topicID === item.topicID || res.packageId === item.topicID)
                })
            }

            if (!this.topics.length) {
                this.onLoadError()
            }
        },

        // 更新 currentTopic、currentImage、currentImageUrl、currentAnswer
        loadCurrent() {
            this.currentTopic = this.topics[this.number - 1]
            this.currentType = 0

            if (this.currentTopic && this.currentTopic.topic) {
                const topic = this.currentTopic.topic
                this.currentImageUrl = topic.url

                this.currentImage = {
                    name: topic.image.name,
                    isSafe: topic.isSafe,
                    description: topic.image.description,
                    marks: topic.marks || topic.image.marks,
                    productName: topic.image.productName,
                    knowledges: [],
                }

                if (this.currentImage.marks?.length) {
                    this.currentImage.knowledges = this.currentImage.marks.map(item => {
                        return item.knowledgeName
                    })
                }

                this.currentAnswer = this.response.find(item => {
                    return item.topicID === this.currentTopic.topicID ||
                        item.packageId === this.currentTopic.topicID
                })

            }
        },

        onChoose(isPass) {
            this.currentAnswer.isPass = isPass
            this.currentTopic.answered = true

            // 快速判断则自动跳题
            if (this.paperInfo.form === 1) {
                this.nextOne()
            }

            // 点安全去掉所有框
            if (isPass) {
                this.currentAnswer.tags = []
            }
        },

        addMark(e) {
            if (!this.canMark) return

            if (this.currentAnswer.tags?.length >= 10) {
                return this.$message.error('标框达到上限！')
            }

            const imgW = this.$refs.xrayImage.clientWidth
            const imgH = this.$refs.xrayImage.clientHeight
            const x = (e.offsetX / imgW).toFixed(2) - 0  // 框圆心距图片左边的比例（小数）
            const y = (e.offsetY / imgH).toFixed(2) - 0    // 框圆心距图片上边的比例（小数）

            if (this.paperInfo.form === 3) {
                this.kpSelector = true
                this.currentX = x
                this.currentY = y
            } else {
                this.currentAnswer.tags.push({x, y})
                // 画框则自动选择嫌疑
                this.onChoose(false)
            }
        },
        delMark(index) {
            if (!this.canMark) return

            this.currentAnswer.tags.splice(index, 1)
        },
        submitTagKp({id, name}) {
            if (!id) return

            const tag = {
                x: this.currentX,
                y: this.currentY,
                tagKp: id,
                tagName: name
            }

            this.currentAnswer.tags.push(tag)
            // 画框则自动选择嫌疑
            this.onChoose(false)

            this.kpSelector = false
        },

        initCountDown() {
            let duration = this.paperInfo.remainSeconds;

            if (!duration) return

            let savedTime = new Date().getTime();

            // 多少秒存一次
            const frequency = this.config.savedTime

            this.cd = new CountDown(duration*1000, (time) => {
                time = time/1000;
                let minute = Math.floor(time / 60);
                let second = time % 60;

                $('.left-time').text(`${minute} ${this.$t('count.min')} ${second} ${this.$t('count.s')}`);

                // 定时保存用户数据到server
                if (new Date().getTime() - savedTime >= frequency * 1000) {
                    savedTime = new Date().getTime();
                    this.savePaperOnServer();
                }
            }, () => {
                this.submitPaper();
            })
        },

        savePaperOnServer() {
            if (this.type === 'mockExam') {
                this.$api.saveFiscanMockExam(this.paperInfo.testID, this.paperInfo.guid, this.response);
            } else {
                this.$api.saveFiscanExam(this.paperInfo.testID, this.response);
            }
        },
        savePaperOnLocal() {
            Storage.set(this.localKey, this.response)
        },

        toSubmit() {
            const leftNum = this.topics.filter(item => !item.answered)?.length
            const msg = (leftNum && leftNum > 0) ? this.$t('m.submitUndonePaper', [leftNum]) : this.$t('m.submitPaper');

            this.showModal = true
            this.modalMessage = msg
        },

        async submitPaper() {
            this.showModal = false

            if (this.type === 'practice') {
                const res = await this.$api.submitFiscanPractice(this.paperInfo.guid, this.paperInfo.form, this.response)
                this.resultID = res.package
            }

            if (this.type === 'exam') {
                await this.$api.submitFiscanExam(this.paperInfo.testID, this.response)
                this.resultID = this.paperInfo.testID
                this.cd.clear()
                Storage.remove(this.localKey)
            }

            if (this.type === 'mockExam') {
                const res = await this.$api.submitFiscanMockExam(this.paperInfo.testID, this.paperInfo.guid, this.response)
                this.mockTestID = this.resultID = res.package
                this.cd.clear()
                Storage.remove(this.localKey)
            }

            this.showResult = true
        },

        onResultClose(isReview) {
            if (isReview) {
                this.reviewPaper()
            } else {
                this.closeFn()
            }
        },

        async reviewPaper(paperID) {
            let data = {}
            if (this.type === 'practice') {
                const res = await this.$api.fiscanPracticeDetail(this.paperInfo.guid || paperID)
                data = res.package
                data.form = this.paperInfo.form
            }

            if (this.type === 'exam') {
                const res = await this.$api.examDetail(this.paperInfo.testID || paperID)
                data = res.package
            }

            if (this.type === 'mockExam') {
                const res = await this.$api.mockExamHistory(this.mockTestID || paperID)
                data = res.package
            }

            this.usage = 2
            this.offEvent()
            this.onShow()
            this.$nextTick(() => {
                this.data = data
                // this.onPaperData(data)
            })
        },

        lastOne() {
            this.number > 1 && this.number--;
        },
        nextOne() {
            this.number < this.topics.length && this.number++;
        },
        // 查看包内物品详情
        viewTipDetail(tipId) {
            if (!tipId) return

            this.kpDetailId = tipId
            this.kpDetailShow = true
        },
        // 点击右侧操作
        operateClick(type) {
            if (this.currentType === type) {
                this.currentType = 0
            } else {
                this.currentType = type
            }

            const operations = this.currentTopic.topic.image.operations
            this.currentImageUrl = operations.find(item => item.type === this.currentType).url
        },
        // 点击右侧考题图像列
        clickTopicList(topicID) {
            if (this.currentTopic.topicID != topicID) {
                this.currentType = 0
                this.currentImageUrl = ''
                let index = this.topics.findIndex(v => v.topicID == topicID)
                this.number = index + 1
            }
        },
        initZoom() {
            this.$nextTick(() => {
                const options = {
                    zoomSpeed: 0.065,
                    maxZoom: 4,
                    minZoom: 1,
                    smoothScroll: false,
                    transformOrigin: {x: 0.5, y: 0.5}, // 缩放中心点
                    zoomDoubleClickSpeed: 1, // 禁止双击放大
                    // 取消键盘事件
                    filterKey: function (/* e, dx, dy, dz */) {
                        return true
                    }
                }

                this.panRate = 0

                this.zoom = panzoom(this.$refs.bigImage, options)

                this.zoom.on('pan', (e) => {
                    this.panRate++

                    // 忽略掉过小的移动幅度
                    if (this.panRate > 5) {
                        this.panning = true
                    }
                })

                this.zoom.on('panend', (e) => {
                    this.panRate = 0

                    setTimeout(() => {
                        this.panning = false
                    }, 0)
                })
            })
        },
        resetZoom(resetOperate) {
            if (resetOperate) {
                this.operateClick(0)
            }

            if (this.zoom) {
                this.zoom.moveTo(0, 0)
                this.zoom.zoomAbs(0, 0, 1)
                this.panning = false
            }
        },

        fullScreen() {
            if (!screenfull.isFull()) {
                screenfull.request(this.$refs.fiscanPaper)
            }
        },
        exitFullScreen() {
            if (screenfull.isFull()) {
                screenfull.exit()
            }
        },

        // 考题加载失败
        onLoadError() {
            this.loading = false
            this.closeFn()
            this.$message.error('考卷加载失败！')
        },

        initEvents() {
            this.initZoom()

            $(document).on('keydown.paper', e => {
                let key = e.keyCode
                // 左
                if (key === 37 || key === 38) {
                    this.lastOne()
                }
                // 右
                if (key === 39 || key === 40) {
                    this.nextOne()
                }
            })

            $(window).on('resize.paper', e => {
                if (!screenfull.isFull()) {
                    this.closeFn()
                }
            })
        },

        closeFn() {
            this.$emit('input', false)
            this.$emit('close')
            this.exitFullScreen()
            this.offEvent()
            this.reset()
        },

        reset() {
            this.number = 1
            this.collapse = false
            this.currentImage = ''

            // if (this.zoom) {
            //     this.resetZoom()
            // } else {
            //     this.initZoom()
            // }
        },

        offEvent() {
            //$(this.$refs.xrayImage).off('load.img')
            $(document).off('keydown.paper')
            $(window).off('resize.track')
            if (this.cd) {
                this.cd.clear()
                this.cd = null
            }
        },

    },
}
</script>

<style lang="scss">
@import 'FiscanPaper';
</style>
